import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Option from './Option';

class Dropdown extends Component {
	constructor(props) {
		super(props);

		// this.opt = this.props.dataSet;
		const { disabled } = this.props;

		this.dropDom = React.createRef();
		this.optDom = React.createRef();

		this.state = {
			dataSet: this.props.dataSet,
			open: false, // local state
			disabled: disabled, // local state
			value: this.props.value,
			openDirection: 'down',
		};
	}
	toggleDropdown = e => {
		if (this.state.disabled) return;
		this.setState({ open: !this.state.open });
	};
	windowClick = e => {
		if (this.dropDom.current === null || this.optDom.current === null)
			return;
		if (
			!this.dropDom.current.contains(e.target) &&
			!this.optDom.current.contains(e.target) &&
			this.state.open
		) {
			this.setState({ open: false });
		}
	};
	componentDidMount() {
		window.addEventListener('click', this.windowClick);

		if (this.state.dataSet.length <= 1) {
			this.setState({ disabled: true });
		}
	}
	componentWillUnmount() {
		window.removeEventListener('click', this.windowClick, false);
	}
	componentDidUpdate(prevProps, prevState) {
		// open and close
		const { open, openDirection } = this.state;

		if (open !== prevState.open) {
			if (open) {
				var checkBtm =
					this.dropDom.current.getBoundingClientRect().bottom +
					2;
				var dynamH = this.optDom.current.children.length * 25 + 2;
				let optionH = Math.min(180, dynamH);
				let winH =
					this.props.wrapperH > 0 ? this.props.wrapperH : 688;
				var extraH = this.props.name === 'dvDrop' ? 22 : 0;
				if (checkBtm + optionH >= winH) {
					this.setState({ openDirection: 'up' });
				} else {
					this.setState({ openDirection: 'down' });
				}
				// open
				this.dropDom.current.classList.add('expand');
				this.optDom.current.classList.add('expand');
				let sel = this.optDom.current.getElementsByClassName(
					'selected'
				);
				if (sel.length > 0) {
					this.optDom.current.scrollTo(0, sel[0].offsetTop);
				}
			} else {
				// close
				this.dropDom.current.classList.remove('expand');
				this.optDom.current.classList.remove('expand');
			}
		}

		if (openDirection !== prevState.openDirection) {
			if (openDirection === 'up') {
				this.optDom.current.style.top = 'unset';
				this.optDom.current.style.bottom = '28px';
			} else {
				this.optDom.current.style.bottom = 'unset';
				this.optDom.current.style.top = extraH + 27 + 'px';
			}
		}

		// update value from parent
		const { value, dataSet } = this.props;

		if (value !== prevProps.value) {
			this.setState({ open: false, disabled: false || this.props.disabled, value: value });
		}

		if (dataSet !== prevProps.dataSet) {
			this.setState({ dataSet: dataSet });
			this.setState({ disabled: dataSet.length <= 1 || this.props.disabled});
		}
	}
	selectOption = value => {
		this.setState({ open: false });
		this.props.selectOption(value);
	};
	render() {
		const { dataSet, open, value, disabled } = this.state;
		const { selectOption, toggleDropdown, dropDom, optDom } = this;

		if (dataSet.length === 0 || value === -1) return null;
		var options = null;
		if (open) {
			options = dataSet.map((item, index) => (
				<Option
					key={index}
					optId={index}
					content={item.name ? item.name : item.content}
					disabled={item.disabled}
					tips={item.tooltip}
					selected={value === index}
					selectOption={selectOption}
				/>
			));
		}
		var dropClass = disabled ? 's3-dropdown disabled' : 's3-dropdown';
		var selected = dataSet[value].name
			? dataSet[value].name
			: dataSet[value].content;
		return (
			<div className="dropdown-area">
				{this.props.syncing ? (
					<div className="loader show" />
				) : null}
				<div
					className={dropClass}
					ref={dropDom}
					onClick={toggleDropdown}
				>
					<div
						className={`selected ${
							selected === 'none' && value === 0
								? 'placeholder'
								: ''
						}`}
					>
						{selected === 'none' && value === 0
							? this.props.placeholder
							: selected}
					</div>
					<div className="icon expand" />
				</div>
				<div className="s3-options flex" ref={optDom}>
					{options}
				</div>
			</div>
		);
	}
}

// PropTypes
Dropdown.propTypes = {
	dataSet: PropTypes.array.isRequired,
	name: PropTypes.string,
	selectOption: PropTypes.func.isRequired,
	value: PropTypes.number.isRequired,
	wrapperH: PropTypes.number,
};

export default Dropdown;
